import React, { useContext } from "react";
import { withRouter, Link, Redirect } from "react-router-dom";

import AuthContext from "../../context/AuthContext";
import useObtenerMunProp from "../../utils/useObtenerMunProp";
import useObtenerUsuario from "../../utils/useObtenerUsuario";

import MPage from "../templates/mpage";

const ImprimirPropuesta = (props) => {
  const { loggedIn } = useContext(AuthContext);
  const [usuario, errorUsuario] = useObtenerUsuario(loggedIn);
  const [municipio, propuesta, errorMunProp] = useObtenerMunProp(
    usuario,
    props.match.params.id
  );

  if (loggedIn === false) return <Redirect to="/login" />;
  if (errorUsuario === true || errorMunProp === true)
    return <Redirect to="/" />;
  if (
    usuario === undefined ||
    municipio === undefined ||
    propuesta === undefined
  )
    return null;
  if (usuario.editarPropuestas === false) return <Redirect to="/consola" />;

  return (
    <MPage municipio={municipio}>
      <div className="row no-print">
        <div className="col-md-8 centrar-col">
          <div className="card my-3" key="mensaje">
            <div className="card-header small">INSTRUCCIONES</div>
            <div className="card-body" style={{ whiteSpace: "pre-line" }}>
              <p className="centrado">
                Presionar "ctrl" + "p" para abrir el cuadro de impresión de la
                propuesta.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="p-5">
        <h2 className="centrado">Propuesta: {propuesta.titulo}</h2>
        <center>
          <h3>{propuesta.subtitulo}</h3>
          {propuesta.eje && (
            <h4>
              <b>Eje: {propuesta.eje}</b>
            </h4>
          )}
          <h4>
            <b>Presupuesto Estimado: $ {propuesta.presupuesto}</b>
          </h4>
        </center>
        <hr className="my-4" />
        <h4>Sobre el autor:</h4>
        <p>
          <b>Nombre del Autor: </b> {propuesta.autor}
        </p>
        {propuesta.dni && (
          <p>
            <b>DNI: </b> {propuesta.dni}
          </p>
        )}
        {propuesta.equipo && (
          <p>
            <b>Equipo: </b> {propuesta.equipo}
          </p>
        )}
        {propuesta.fechaNacimiento && (
          <p>
            <b>Fecha de nacimiento: </b>
            {propuesta.fechaNacimiento}
          </p>
        )}
        {propuesta.email && (
          <p>
            <b>Email: </b>
            {propuesta.email}
          </p>
        )}
        {propuesta.tel && (
          <p>
            <b>Teléfono: </b> {propuesta.tel}
          </p>
        )}
        {propuesta.direccion && (
          <p>
            <b>Dirección: </b> {propuesta.direccion}
          </p>
        )}
        <hr />
        <h4>Más Información Sobre la Propuesta:</h4>

        <p>
          <b>Objetivos:</b>
        </p>
        <div style={{ whiteSpace: "pre-line" }} className="text-justify">
          {propuesta.objetivos}
        </div>

        <p>
          <b>Beneficiarios:</b>
        </p>
        <div style={{ whiteSpace: "pre-line" }} className="text-justify">
          {propuesta.beneficiarios}
        </div>

        <p>
          <b>Lugar de acción:</b>
        </p>
        <div style={{ whiteSpace: "pre-line" }} className="text-justify">
          {propuesta.laccion}
        </div>

        <p>
          <b>Resultados esperados:</b>
        </p>
        <div style={{ whiteSpace: "pre-line" }} className="text-justify">
          {propuesta.resultados}
        </div>

        <p>
          <b>Periodo de ejecución:</b>
        </p>
        <div style={{ whiteSpace: "pre-line" }} className="text-justify">
          {propuesta.pejecucion}
        </div>

        <p>
          <b>Descripción general:</b>
        </p>
        <div style={{ whiteSpace: "pre-line" }} className="text-justify">
          {propuesta.descripcion}
        </div>
        {propuesta.doc && (
          <div className="my-3">
            <a
              className="ppr-a"
              href={`/api/public/${propuesta.doc}`}
              target="_blank"
              rel="noopener noreferrer"
              download
            >
              Documentación Anexa
            </a>
          </div>
        )}
        <hr />
        <div>
          {propuesta.observaciones.map((obs, index) => (
            <div className="card mb-3" key={index}>
              <div className="card-header small">OBSERVACIÓN ({obs.fecha})</div>
              <div className="card-body" style={{ whiteSpace: "pre-line" }}>
                {obs.mensaje}
              </div>
            </div>
          ))}
        </div>
        <center>
          <Link
            to={`/consola`}
            className="btn ppr-btn-verde font-weight-bold m-2 no-print"
          >
            Volver
          </Link>
        </center>
      </div>
    </MPage>
  );
};

export default withRouter(ImprimirPropuesta);
